<script setup>
  import {computed, ref} from "vue";

  import ComponentBmpExportDialog from "@components/Dialogs/BmpExportDialog.vue";
  import {router, usePage} from "@inertiajs/vue3";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "MedicationComponentPlanPrint",
  });

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
    reloadRecord: {
      type: Boolean,
      default: false,
    },
  });

  const page = usePage();

  const bmpDialog = ref(null);
  const loading = ref(false);

  const patientData = computed(() => page.props.patient ?? {});
  const recordData = computed(() => page.props.record ?? {});
  const medicationsData = computed(() => page.props.medications ?? []);
  const laborvaluesData = computed(() => page.props.laborvalues ?? []);
  const diseasesData = computed(() => page.props.diseases ?? []);

  const openMedicationPlanExport = () => {
    if (props.reloadRecord) {
      // we have to reload the page props before
      // opening the bmp dialog (only necessary
      // on record.edit, because due to drag
      // and drop, order might change
      // without an explicit reload
      loading.value = true;
      router.reload({
        only: ["record", "medications", "laborvalues", "diseases"],
        onFinish: () => {
          // at least we do not care, if reloading the data was successful.
          // it's better to show an unsorted bmp instead of showing no
          // bmp manager at all.
          bmpDialog.value.open();
          loading.value = false;
        },
      });
    } else {
      // immediately open bmp dialog
      bmpDialog.value.open();
    }
  };
</script>

<template>
  <MedButton
    variant="primary"
    flat
    icon="description"
    :is-loading="loading"
    :disabled="disabled"
    :data-test="getTestId('plan-print-open-medication-button')"
    @click="openMedicationPlanExport()"
  >
    Medikationsplan erstellen / drucken
  </MedButton>

  <ComponentBmpExportDialog
    ref="bmpDialog"
    :patient="patientData"
    :record="recordData"
    :medications="medicationsData"
    :laborvalues="laborvaluesData"
    :diseases="diseasesData"
    :test-id="getTestId('plan-print')"
  />
</template>
